import styles from "./IncentivisedBadge.scss";
import classnamesBind from "classnames/bind";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

const classnames = classnamesBind.bind(styles);

const IncentivisedBadge = () => {
  const { getTranslation } = useRuntimeConstants();

  return (
    <div className={classnames(styles.incentivised, "product-incentivised")}>
      {getTranslation("pdp_ratings_reviews_incentivized_review_badge_text")}
    </div>
  );
};

export default IncentivisedBadge;
